import { ChevronLeft, Mail } from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import { ZipCodeCheckerMobile } from '../../atomic/zipcodechecker/mobile/ZipCodeCheckerMobile'
import { DataContext } from '../../context-api/DataProvider';
import { StoreHeaderDataContext } from '../../context-api/StoreHeaderDataProvider';
import { emailRegex } from '../../global/constants';
import NO_SERVICE_ANIMATION from "../../global/assets/animation/no_service_available.json";
import Lottie from 'lottie-react';
import InputBox from '../../atomic/inputbox/InputBox';
import AtomicButton from '../../atomic/button/AtomicButton';
import variables from "../../global/assets/_variables.scss";
import EMAIL_SEND_PNG from "../../global/assets/png/mail.png";

const submitButtonStyle = {
    margin: "0px 0px 0px 5px",
    background: variables.backgroundDarkBlue,
    width: "70px",
    height: "40px"
}

export const FirstTimeCheckerMobile = () => {
    const [email, setEmail] = useState("");
    const [enteredZipcode, setEnteredZipcode] = useState("");
    const [isEmailFormatValid, setEmailFormatValid] = useState(true);
    const { kitchensByZipcode, zipcode, clearZipcodeFromLocalStorage, setZipcode, setIsDeliverable, setHeaderVisibility } = useContext(StoreHeaderDataContext) || {};
    const { success, totalKitchens } = kitchensByZipcode;
    const {
        createFutureCustomerData,
        setCreateFutureCustomerData,
        onCreateFutureCustomer,
    } = useContext(DataContext);

    const handleEmailChange = (e) => {
        const emailInput = e.target.value;
        const isEmailValid = emailRegex.test(emailInput);
        setEmailFormatValid(isEmailValid);
        setEmail(emailInput);
    };

    const onEmailSubmit = () => {
        onCreateFutureCustomer({
            email,
            zipcode: zipcode || enteredZipcode,
            manual_notes: "firstTimeServiceChecker",
        });
    };

    const onEnterNewZipcode = () => {
        clearZipcodeFromLocalStorage();
        setZipcode("");
    }



    useEffect(() => {
        if (zipcode) {
            setEnteredZipcode(zipcode)
        }
    }, [zipcode]);

    useEffect(() => {
        if (success) {
            setEmail("");
            setCreateFutureCustomerData({
                ...createFutureCustomerData,
                success: false,
            });
        }
        if (totalKitchens > 0) {
            setIsDeliverable(true);
        }
    }, [success, totalKitchens]);


    useEffect(() => {
        setHeaderVisibility(false);
        return () => {
            setHeaderVisibility(true);
        }
    }, [])

    return (
        <div className="firstime-checker-mobile">
            {success && <ZipCodeCheckerMobile />}
            {!success && (
                <div className="main-container">
                    <div>

                        <IconButton disableRipple onClick={onEnterNewZipcode}>
                            <ChevronLeft />
                        </IconButton>
                        <div className="header-text">Sorry We're not there yet!</div>
                        <Lottie
                            animationData={NO_SERVICE_ANIMATION}
                            loop={true}
                            className="animation-container"
                        />
                        <div className="info-text">Service unavailable in your area at the moment – but we’re coming soon!</div>
                    </div>
                    <div className="future-customer-container">
                        <div className="email-form-title">
                            Grab Your $50 Discount Now
                        </div>
                        <div className="email-form-coupon">Coming Soon Near You – Claim Your $50 Savings Today!</div>


                        {!createFutureCustomerData.success ?
                            <div className="email-button-container">
                                <InputBox
                                    label="Email"
                                    type="email"
                                    size="small"
                                    width="62vw"
                                    height="45px"
                                    sx={{ background: "white" }}
                                    name="email"
                                    value={email}
                                    onChange={handleEmailChange}
                                    inputErrorMsg={isEmailFormatValid ? "" : "Invalid email format"}
                                    error={!isEmailFormatValid}
                                    inputProps={{
                                        startAdornment: (
                                            <InputAdornment position='start'>
                                                <Mail />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                                <AtomicButton
                                    label="SUBMIT"
                                    style={submitButtonStyle}
                                    loadingButtonStyle={{ ...submitButtonStyle, background: variables.backgroundDisabled }}
                                    disabled={!isEmailFormatValid}
                                    handleSubmit={onEmailSubmit}
                                />
                            </div>
                            :
                            <div className="thank-you-box">
                                <img
                                    className="eat_img"
                                    src={EMAIL_SEND_PNG}
                                    alt="Thank Email Sent"
                                />
                                <div className="thank-you-content">
                                    <span className="thanks-msg1">Thank you</span>
                                    <span className="thanks-msg2">We’ll send your discount coupon shortly.</span>
                                </div>
                            </div>
                        }


                        {!success && <AtomicButton
                            label="Enter new Zipcode"
                            style={{
                                background: variables.backGroundLightBlue,
                                width: "207px",
                                height: "45px",
                                marginTop: '20px'
                            }}
                            handleSubmit={onEnterNewZipcode}
                        />}
                        <div style={{ height: '200px', color: 'white' }}>

                            Empty Space for mobile
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
